import { useEffect, useMemo, useState } from 'react';
import { categoryService } from '../services/tasks/categoryService.js';

/**
 * Catalogo de categorias de tarea resuelto a mapas: nombre visible y orden por
 * identificador. Se pide una sola vez al montar y no depende de la fecha.
 */
export const useCategoryCatalog = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isActive = true;

    const fetchCategories = async () => {
      try {
        setLoading(true);
        const { categories: data } = await categoryService.getCategories();

        if (!isActive) return;

        setCategories(data);
        setError(null);
      } catch (fetchError) {
        if (!isActive) return;

        // El catalogo caido degrada los nombres a su identificador, no rompe la vista
        console.error('Error cargando el catalogo de categorias:', fetchError);
        setError(fetchError);
        setCategories([]);
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    fetchCategories();

    return () => {
      isActive = false;
    };
  }, []);

  return useMemo(() => {
    const displayNameByName = new Map();
    const orderIndexByName = new Map();

    categories.forEach((category, index) => {
      if (!category?.name) return;

      displayNameByName.set(category.name, category.displayName || category.name);
      orderIndexByName.set(category.name, index);
    });

    return { displayNameByName, orderIndexByName, loading, error };
  }, [categories, error, loading]);
};
